import React, { useRef, useState, useEffect } from 'react';
import '../App.css';
import '../scss/App.scss';
import SEO from '../seo/SEO';


function Vrdarshan() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showIcon, setShowIcon] = useState(true); // controls icon visibility

  const toggleVideo = () => {
    const video = videoRef.current;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

    // Show icon briefly when toggling
    setShowIcon(true);
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
    setShowIcon(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
    setShowIcon(true);
  };

  // Optional: hide icon after 2 seconds
  useEffect(() => {
    if (showIcon) {
      const timer = setTimeout(() => setShowIcon(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [showIcon]);
  return (
    <>
      <SEO pageKey="vrDarshanOld" />
      <div className="video-container" onClick={toggleVideo}>
      <video
        className="bg-video"
        ref={videoRef}
        muted
        loop
        playsInline
        preload="auto"
        onPlay={handleVideoPlay}
        onPause={handleVideoPause}
        controls
      >
        <source src="../assets/vr-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {showIcon && (
        <div className="icon-overlay d-flex justify-content-center align-items-center">
          <div className="icon-button">
            {isPlaying ? <i className='fa fa-play'></i> : <i className='fa fa-pause'></i>}
          </div>
        </div>
      )}
    </div>
    </>
  );
}
export default Vrdarshan;